/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import tokenProvider from '../utils/token';
import qs from 'qs';

axios.interceptors.request.use(async (config) => {
  const accessToken = tokenProvider.getToken();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

function addParamsSerializer(options) {
  options.paramsSerializer = parameter =>
    qs.stringify(parameter, { arrayFormat: 'repeat' });
}

function extractFilename(disposition) {
  
  const defaultFileName = 'download.json';

  if (!disposition) 
    return defaultFileName;

  // Try UTF-8 encoded filename* first
  const utf8Match = disposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/i);
  if (utf8Match) {
    return decodeURIComponent(utf8Match[1]) || defaultFileName;
  }

  // Fallback: regular filename
  const asciiMatch = disposition.match(/filename="?([^"]+)"?/i);
  return asciiMatch?.[1]?.trim() || defaultFileName;
}

function triggerFileDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default {
  async get(url, options = {}) {
    addParamsSerializer(options);

    const response = await axios.get(url, options);
    return response.data;
  },
  async post(url, data = {}, options = {}) {
    addParamsSerializer(options);
    const response = await axios.post(url, data, options);
    return response.data;
  },
  async put(url, data = {}, options = {}) {
    const response = await axios.put(url, data, options);
    return response.data;
  },
  async patch(url, data = {}, options = {}) {
    const response = await axios.patch(url, data, options);
    return response.data;
  },
  async delete(url, options = {}) {
    const response = await axios.delete(url, options);
    return response.data;
  },
  async downloadFile(url, data = {}, options = {}) {
    return await axios.request({
      url,
      method: 'GET',
      responseType: 'blob',
      data,
      options,
    });
  },
  async downloadAndSaveFile(url, options = {}) {

    console.log(url);
    const response = await axios.get(url, {
      responseType: 'blob',
      ...options,
    });

    const disposition = response.headers['content-disposition'];
    const filename = extractFilename(disposition);
    triggerFileDownload(response.data, filename);
  },
};
